import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// currency helpers
export const CURRENCY_SYMBOLS = {
  INR: "₹",
  USD: "$",
  GBP: "£",
  AED: "AED ",
  CAD: "C$",
  AUD: "A$",
};

export const CURRENCIES = ["INR", "USD", "GBP", "AED", "CAD", "AUD"];

// Simple in-memory currency rate cache. Values populated at app boot.
export let RATES = { INR: 1, USD: 0.012, GBP: 0.0095, AED: 0.044, CAD: 0.0165, AUD: 0.0185 };

export function setRates(rates) {
  RATES = { ...RATES, ...rates };
}

export function formatPrice(inrAmount, currency = "INR") {
  const rate = RATES[currency] ?? 1;
  const converted = (inrAmount || 0) * rate;
  const sym = CURRENCY_SYMBOLS[currency] || "";
  if (currency === "INR") {
    return `${sym}${Math.round(converted).toLocaleString("en-IN")}`;
  }
  return `${sym}${converted.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
